export const CLINICAL_ROLES = ["Internal Medicine", "Family Medicine", "Pharmacist"];
